import { LatLng } from "react-google-places-autocomplete/build/types";
import { directsearchAxios } from "../Services/axios";

import {
  getAvailabilityPayload,
  Hotel,
  HotelDetails,
  SearchHotelReturnType,
  SearchNearbyReturnType,
  SearchParameters,
  wsAvailability,
} from "../Services/wsSearch";

export const MIN_PRICE = 10;
export const MAX_PRICE = 1000;

export type AutocompleteLocation = {
  label: string;
  secondaryLabel?: string;
  placeId?: string;
  collectionId?: string;
  nearby?: boolean;
  extra?: boolean;
  collections?: number;
};

export async function autocomplete(
  query: string,
  language = "it",
): Promise<AutocompleteLocation[]> {
  if (!query) return [];

  try {
    const res = await directsearchAxios.request({
      url: "directsearch/autocomplete",
      params: { query, language },
    });
    return res.data.places;
  } catch (e) {
    console.error(e);
    return [];
  }
}

export async function getViewport(placeId: string): Promise<
  | {
      northeast: LatLng;
      southwest: LatLng;
    }
  | undefined
> {
  try {
    const res = await directsearchAxios.request({
      url: "directsearch/viewport",
      params: { placeId },
    });
    return res.data.viewport;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

export async function searchHotels(
  params: SearchParameters,
): Promise<SearchHotelReturnType | undefined> {
  try {
    const res = await directsearchAxios.post<SearchHotelReturnType>(
      "directsearch/search",
      params,
    );

    return res.data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

export async function getHotelDetails(
  id: string,
  lang?: string,
): Promise<HotelDetails | undefined> {
  try {
    const res = await directsearchAxios.get<HotelDetails>(
      `directsearch/details/${id}`,
      {
        params: {
          lang,
        },
      },
    );

    return res.data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

export async function getHotelAvailability(
  availabilityParams: getAvailabilityPayload,
  searchParams?: SearchParameters,
): Promise<wsAvailability | undefined> {
  try {
    const res = await directsearchAxios.post<wsAvailability>(
      `directsearch/availability`,
      {
        availabilityParams,
        searchParams,
      },
    );

    return res.data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

export async function searchNearby(
  params: SearchParameters,
): Promise<SearchNearbyReturnType | undefined> {
  try {
    const res = await directsearchAxios.request<SearchNearbyReturnType>({
      method: "POST",
      url: "directsearch/nearby",
      params,
    });
    return res.data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

export async function getHotels(ids: string[]): Promise<Hotel[]> {
  if (!ids || ids.length === 0) return [];

  try {
    const res = await directsearchAxios.request({
      url: "directsearch/hotels",
      params: { ids },
    });
    return res.data.hotels;
  } catch (e) {
    console.error(e);
    return [];
  }
}

export function getQueryString(params: object) {
  const queryString = Object.entries(params)
    .filter(([_, v]) => !!v)
    .map(([k, v]) => {
      if (typeof v === "object") {
        return `${k}=${encodeURIComponent(JSON.stringify(v))}`;
      }
      return `${k}=${encodeURIComponent(v)}`;
    })
    .join("&");
  return queryString;
}
